import { useFlags } from 'launchdarkly-react-client-sdk';
import React from 'react';
import Submission from './Submissions/Submissions.container';
import SubmissionV4 from './Submissionsv4/Submissions.container';
import SubmissionsResponsive from './AssignmentsResponsive/SubmissionsResponsive/SubmissionsResponsive.container';

const SubmissionToggle = (props) => {
  const {
    assignmentDetailsPageMuiV6202502,
    webAppFtResponsiveAssignments202607,
  } = useFlags();

  if (webAppFtResponsiveAssignments202607) {
    return <SubmissionsResponsive {...props} />;
  }

  return assignmentDetailsPageMuiV6202502 ? (
    <Submission {...props} />
  ) : (
    <SubmissionV4 {...props} />
  );
};

export default SubmissionToggle;
